document.addEventListener('DOMContentLoaded', function() {
	const updateQuantity = (input, increment, originalText) => {
		const hiddenInput = input.nextElementSibling;
		const titleBlock = input.previousElementSibling;
		let value = increment === null ? parseInt(input.value) || 0 : (parseInt(input.value) || 0) + increment;

		if (value > 0) {
			input.value = value;
			hiddenInput.setAttribute('data-quantity', value);
			titleBlock.classList.add("focus_input");
		} else {
			input.value = originalText;
			hiddenInput.removeAttribute('data-quantity');
			titleBlock.classList.remove("focus_input");
		}
		toggleMinusButton(input, value > 0);
	};

	const toggleMinusButton = (input, isVisible) => {
		const minusButton = input.closest('.product-upsale__quantity-selector').querySelector('.product-upsale__quantity-selector-minus');
		minusButton.style.width = isVisible ? 'auto' : '0';
		minusButton.style.padding = isVisible ? '10px' : '0';
	};

	const setupQuantitySelector = (selector) => {
		const plusButton = selector.querySelector('.product-upsale__quantity-selector-plus');
		const minusButton = selector.querySelector('.product-upsale__quantity-selector-minus');
		const input = selector.querySelector('.product-upsale__quantity-selector-input');
		const originalText = input.value;

		// Check the availability from the data-available attribute
		const isAvailable = input.dataset.avialible === 'true';

		if (!isAvailable) {
			// Product is not available
			input.classList.add('disabled')
			input.disabled = true; // Disable the input
			if (plusButton) {
				plusButton.disabled = true;
				plusButton.classList.add('disabled');
			}
			if (minusButton) minusButton.disabled = true; // Disable the minus button
		} else {
			// Product is available
			if (plusButton) {
				plusButton.addEventListener('click', () => updateQuantity(input, 1, originalText));
				plusButton.disabled = false; // Ensure button is enabled
			}
			if (minusButton) {
				minusButton.addEventListener('click', () => updateQuantity(input, -1, originalText));
				minusButton.disabled = false; // Ensure button is enabled
			}
			input.disabled = false; // Ensure input is enabled
			input.addEventListener('input', () => handleInput(input, originalText));
			input.addEventListener('click', () => handleInputClick(input));
			input.addEventListener('blur', () => handleInputBlur(input, originalText));
		}
	};

	const handleInput = (input, originalText) => {
		const numValue = parseInt(input.value);
		const validNumber = !isNaN(numValue) && numValue > 0;
		updateQuantity(input, null, originalText);
		toggleMinusButton(input, validNumber);
	};

	const handleInputClick = (input) => {
		if (isNaN(parseInt(input.value))) {
			input.value = '';
		}
		toggleMinusButton(input, parseInt(input.value) > 0);
	};

	const handleInputBlur = (input, originalText) => {
		if (input.value === '') {
			input.value = originalText;
			input.nextElementSibling.removeAttribute('data-quantity');
			toggleMinusButton(input, false);
		}
	};

	document.querySelectorAll('.product-upsale__quantity-selector').forEach(setupQuantitySelector);
});
